<div class="preloader">
	<div class="spinner-wrap">
		 <div class="preloader-logo">
			  <img src="https://imagineapps.co/_assets/v11/8c8fe80147819ebbab415af8999241511f76c6c2.png" alt="" class="img-fluid">
		 </div>
		 <div class="spinner"></div> 
	</div>
</div>